// 全局服务器配置（静态 env.js 手动切换环境）
import { ENV, ENV_CONFIG } from './env'

const CURRENT = ENV_CONFIG[ENV] || ENV_CONFIG.dev;

export const SERVER_CONF = {
  BASE_URL: CURRENT.BASE_URL,
  FILE_UPLOAD: '/file-handle/upload',
  FILE_UPLOAD_BATCH: '/file-handle/upload-by-batch'
}

export const buildUrl = (path='') => {
  const base = SERVER_CONF.BASE_URL.replace(/\/$/, '')
  if(!path) return base
  return `${base}${path.startsWith('/')? path : '/' + path}`
}
